import { useState } from "react";
import { FaFileAlt } from "react-icons/fa";
import AOS from 'aos';
import 'aos/dist/aos.css';

const categories = [
    "Základní Pravidla",
    "Dodatkové Pravidla",
    "Základní Pojmy",
    "Pravidla vykrádání/nelegální",
    "Gang Pravidla",
    "Pravidla Nelegální scény",
    "Pravidla Cayo Perico"
];

const rulesData = {
    "Základní Pravidla": [
        {
            title: "Minimální věk",
            content: [
                {
                    text: `Pro připojení na náš server je minimální věk 15 let. V případě nižšího věku je možné požádat o výjimku prostřednictvím pohovoru na Discordu.`
                }
            ]
        },
        {
            title: "Funkční mikrofon",
            content: [
                {
                    text: "Je požadován funkční a kvalitní mikrofon pro komunikaci během roleplay situací."
                }
            ]
        },
        {
            title: "Reálné jméno",
            content: [
                {
                    text: "Vaše postava musí mít reálné jméno a nesmí porušovat podmínky služby (TOS - Terms of Service)."
                }
            ]
        },
        {
            title: "Zákaz toxicity",
            content: [
                {
                    text: "Je přísně zakázáno být vulgární, toxický nebo šířit toxicitu na jakékoli platformě (např. Twitch, Discord, atd.). Porušení tohoto pravidla může vést k zabanování z serveru nebo platforem."
                }
            ]
        }
    ],
    "Dodatkové Pravidla": [
        {
            title: "Žádost o frakce",
            content: [
                {
                    subtitle: "Ukradený lore",
                    text: `V žádném případě není možné schválit frakci, která využívá ukradený lore. Všechny žádosti o frakce musí mít originální příběh a obsah.`
                }
            ]
        },
        {
            title: "Úpravy hry",
            content: [
                {
                    subtitle: "Zakázané úpravy",
                    text: `Je přísně zakázáno jakýmkoliv způsobem upravovat hru pro vlastní výhodu. To zahrnuje úpravy jako killfx, bloodfx nebo jakékoliv mody v citizenech.`
                },
                {
                    subtitle: "Povolené úpravy",
                    text: `Vizualizace úpravy hry (například NVE mod) je povolena, pokud nezvýhodňuje hráče v rámci hry.`
                }
            ]
        },
        {
            title: "Zamykání se v interiéru při RP akci",
            content: [
                {
                    subtitle: "Zakázané zamykání",
                    text: `Je zakázáno utíkat od RP akce tím, že se zamknete v interiéru, který je jinak nepřístupný.`
                },
                {
                    subtitle: "Únik při RP",
                    text: `Pokud jste naháněni PD/SD nebo jinými frakcemi, můžete se ukrýt pouze na místech, která jsou volně přístupná bez použití zámků.`
                }
            ]
        },
        {
            title: "Poznávání osob",
            content: [
                {
                    subtitle: "Bez poznání",
                    text: `Není povoleno poznávat hráče pouze podle hlasu, oblečení nebo auta.`
                },
                {
                    subtitle: "Dlouhodobější RP",
                    text: `Abyste mohli skutečně poznat osobu, musíte mít s ní dlouhodobější RP akci.`
                }
            ]
        },
        {
            title: "Pravidlo bydlení",
            content: [
                {
                    subtitle: "Trvalé bydliště",
                    text: `Každá postava musí mít trvalé bydliště. Pokud chcete RPit bezdomovce, musíte mít schválený ticket pro tento účel.`
                }
            ]
        },
        {
            title: "Crosshair",
            content: [
                {
                    subtitle: "Povolení Crosshairu",
                    text: `Crosshair není na serveru zakázán.`
                }
            ]
        },
        {
            title: "Skiny",
            content: [
                {
                    subtitle: "Zakázané skiny na zbraně",
                    text: `Je přísně zakázáno používat skiny na zbraně, které mohou ovlivnit RP hru nebo herní mechaniky.`
                }
            ]
        },
        {
            title: "CPZ",
            content: [
                {
                    subtitle: "Maximální doba v CPZ",
                    text: `Hráče v CPZ není možné držet déle než 48 hodin bez relevantního RP důvodu.`
                },
                {
                    subtitle: "Výjimka",
                    text: `Pokud chcete prodloužit dobu zadržení, musíte o to požádat prostřednictvím DOJ ticketu.`
                }
            ]
        },
        {
            title: "Multichar",
            content: [
                {
                    subtitle: "Počet postav",
                    text: `Každý hráč má 2 sloty pro postavy.`
                },
                {
                    subtitle: "Zakázané frakce",
                    text: `Je zakázáno být za obě postavy ve jedné frakci.`
                },
                {
                    subtitle: "Zakázané kombinace postav",
                    text: `Je přísně zakázáno mít postavu ve vyšší pozici v legálních frakcích, pokud vaše druhá postava patří do nelegální frakce.`
                },
                {
                    subtitle: "Výjimky",
                    text: `Výjimku je možné udělit pouze prostřednictvím ticketu.`
                },
                {
                    subtitle: "Předávání majetku",
                    text: `Je přísně zakázáno předávání majetku z jednoho charu na druhý.`
                }
            ]
        },
        {
            title: "Streamsniping",
            content: [
                {
                    subtitle: "Zákaz informací ze streamu",
                    text: `Zakázáno využívání informací, které získáme skrze stream přítomného hráče na serveru.`
                },
                {
                    subtitle: "Zákaz vyhledávání",
                    text: `Zakázáno úmyslné vyhledávání hráče, který sdílí svou polohu skrze živé vysílání.`
                },
                {
                    subtitle: "Zákaz ovlivňování hráčů",
                    text: `Zakázáno ovlivňování hráčů skrze stream – případné nabádání k ovlivnění vývoje celé RP akce, v případě, kdy dotyčný hráč není fyzicky přítomen ve hře.`
                }
            ]
        }
    ],

    "Základní Pojmy": [
        {
            title: "/ME",
            content: [
                {
                    subtitle: "Popis",
                    text: "Slouží k nahrazení animací, které nejsou dostupné ve hře. Tento příkaz umožňuje podpořit kvalitnější RP a zlepšit prožitek ze hry."
                },
                {
                    subtitle: "Příklad",
                    text: "/me bere peníze ze stolu<br/>/me hladí po obličeji"
                }
            ]
        },
        {
            title: "/DO",
            content: [
                {
                    subtitle: "Popis",
                    text: "Slouží k doplnění příkazu /ME a k vykonání činnosti s očekávanou reakcí k popisu události nebo stavu."
                },
                {
                    subtitle: "Pravidla",
                    text: "Do příkazu /DO je zakázáno psát lži, pocity nebo myšlenky."
                },
                {
                    subtitle: "Příklad",
                    text: "/Do tržná rána v oblasti hlavy<br/>/Do Jaké vidí jméno?"
                }
            ]
        },
        {
            title: "/TRY",
            content: [
                {
                    subtitle: "Popis",
                    text: "Slouží k odpovědím ANO/NE"
                },
                {
                    subtitle: "Zakázáno",
                    text: "Zakázáno používat při injuries"
                },
                {
                    subtitle: "Výjimka",
                    text: "Např. při prosakování obvazu pouze jen v případě že je tam druhá osoba"
                }
            ]
        },
        {
            title: "IC / OOC",
            content: [
                {
                    subtitle: "IC",
                    text: "In Character - Vše ve fiktivním světě ve státě San Andreas."
                },
                {
                    subtitle: "OOC",
                    text: "Out Of Character - Vše mimo fiktivní svět."
                }
            ]
        },
        {
            title: "Passive RP",
            content: [
                {
                    subtitle: "",
                    text: "RPÍ se Milionové město, na hlavních garážích, EMS, PD, PODNIKY atd… je několik lidí. Na těchto místech je přísně zakázáno okrádat, vytahovat zbraně a zabíjet ostatní hráče i NPC! Jediné možné místo jsou podniky při dobrém RP! Pokud chcete například vypálit nějaký podnik musíte si založit ticket a čekat na schválení od A-Teamu."
                }
            ]
        },
        {
            title: "Mixing",
            content: [
                {
                    subtitle: "Popis",
                    text: "Míchání frází z reálného světa do světa fiktivního ( Míchání OOC pojmů do IC )."
                },
                {
                    subtitle: "Příklady",
                    text: "Pojď na discord<br/>Jsem v čekárně<br/>je zakázano říkat 'svalem E se dělá tohle' atd..."
                }
            ]
        },
        {
            title: "Metagaming",
            content: [
                {
                    subtitle: "Popis",
                    text: "Zjišťování informací mimo fiktivní svět s jejím následným využitím v něm."
                },
                {
                    subtitle: "Příklad",
                    text: "Viděl jsem na streamu lokaci drog, rovnou tam pojedu a budu dělat že jsem to celou dobu věděl."
                }
            ]
        },
        {
            title: "Water Evading",
            content: [
                {
                    subtitle: "Popis",
                    text: "Unikání před policií za pomocí vody, nevztahuje se na místa kde má policie šanci vás dohnat (rybníky a menší řeky se mohou)."
                }
            ]
        },
        {
            title: "CopBaiting",
            content: [
                {
                    subtitle: "Popis",
                    text: "Je přísně zakázáno záměrně provokovat státní složky (LSPD, LSSD apod.) bez adekvátního RP důvodu."
                },
                {
                    subtitle: "Příklady",
                    text: "Driftování nebo rychlá jízda kolem policejní stanice.<br/>Záměrné troubení, nadávání, gestikulace nebo jiné projevy za účelem přitáhnutí pozornosti.<br/>Úmyslné přibližování se k probíhajícím policejním zásahům nebo jejich narušování."
                }
            ]
        },
        {
            title: "NonRP Driving",
            content: [
                {
                    subtitle: "Popis",
                    text: "Nereálné řízení vozidla, ať již z důvodu jeho poškození či výšky atd..."
                },
                {
                    subtitle: "Příklad",
                    text: "Byla ti prostřelena guma a ty si jedeš bez problému dál."
                }
            ]
        },
        {
            title: "NonRP Injuries",
            content: [
                {
                    subtitle: "Neerpení obdrženého zranění.",
                    text: "Slova typu Au,Kur*a,atp.. se nepovažují za adekvátní RP! K tomuto slouží /ME & /DO"
                },
                {
                    subtitle: "Příklad",
                    text: "Nabouráš ve vysoké rychlosti a jedeš si v klidu dál"
                }
            ]
        },
        {
            title: "Loot Boxing",
            content: [
                {
                    subtitle: "",
                    text: "Je přísně zakázáno bez adekvátního RP kohokoli okrádat!"
                }
            ]
        },
        {
            title: "New Life Rule (NLR)",
            content: [
                {
                    subtitle: "Popis",
                    text: "Pokud jste zastřeleni a znovu se respawnete v nemocnici, vaše postava zapomene na bezprostřední události, které vedly k zastřelení v aktuálním RP. Pokud bylo sděleno, že EMS je na cestě, nesmíte se respawnovat."
                },
                {
                    subtitle: "Povinnost",
                    text: "Musíte se pokusit kontaktovat nějakou lékařskou pomoc, když jste zraněni."
                }
            ]
        },
        {
            title: "Pravidlo Inventáře",
            content: [
                {
                    subtitle: "",
                    text: "Vše co máte u sebe, máte opravdu u sebe a musíte to přiznat i do /DO."
                }
            ]
        },
        {
            title: "Fail RP",
            content: [
                {
                    subtitle: "Popis",
                    text: "Postava musí vždy jednat přiměřeně své situaci, schopnostem a vlastnostem. Je zakázáno jednat způsobem, který by v reálném světě nebyl možný nebo logický (například skákání z budovy bez důvodu, ignorování zranění, útěk z vězení bez plánování apod.)."
                },
                {
                    subtitle: "Zneužívání",
                    text: "Jakákoliv činnost, která porušuje herní fyziku nebo logiku prostředí, se považuje za FailRP (např. vyhýbání se zátarasům projížděním nerealistickými cestami)."
                },
                {
                    subtitle: "Vyhýbání",
                    text: "Vyhýbání se RP situacím, které by měly důsledek pro vaši postavu (např. ignorování interakce s policií, úmyslné odpojení během situace)."
                },
                {
                    subtitle: "Využívání mechanik",
                    text: "Zneužívání herních mechanik pro získání výhody (např. schovávání zbraní či předmětů na nerealistická místa)."
                },
                {
                    subtitle: "Příklady",
                    text: "Řízení auta přes vodu nebo jiným způsobem nerealistické jednání s vozidlem.<br/>Odmítnutí RP zranění nebo smrti, které by logicky nastaly během situace."
                }
            ]
        },
        {
            title: "Combat Log",
            content: [
                {
                    subtitle: "Popis",
                    text: "Je zakázáno se úmyslně odpojovat během RP akce (například během honičky, zatýkání, přestřelky, loupeže nebo zranění)."
                },
                {
                    subtitle: "Technické problémy",
                    text: "Pokud dojde k technickým problémům (například pád hry nebo ztráta připojení), je hráč povinen se co nejdříve znovu připojit na server a kontaktovat zúčastněné hráče nebo admin tým."
                },
                {
                    subtitle: "Zneužití",
                    text: "Hráč nesmí využívat odpojení jako způsob vyhnutí se trestu, ztrátě zbraní, peněz nebo jiných RP důsledků."
                },
                {
                    subtitle: "Odchod",
                    text: "Pokud potřebujete odejít ze hry, vždy informujte ostatní hráče a dohodněte se na ukončení situace přiměřeným způsobem."
                }
            ]
        },
        {
            title: "NVL - Not Valuing your life",
            content: [
                {
                    subtitle: "Popis",
                    text: "Musíte si vážit svého života. Hráč musí vždy jednat tak, aby jeho postava projevovala přiměřený strach o svůj život v situacích, kdy je v ohrožení."
                },
                {
                    subtitle: "Zakázáno",
                    text: "Je zakázáno úmyslně ignorovat nebo vzdorovat ozbrojeným útočníkům, pokud nemá reálnou šanci na úspěšnou obranu (např. být neozbrojen a postavit se proti přesile)."
                },
                {
                    subtitle: "Majetek",
                    text: "Nelze riskovat život své postavy kvůli majetku, například odmítnutím spolupráce při loupeži, kdy je hrozba jasně vyjádřena."
                },
                {
                    subtitle: "Další případy",
                    text: "Ignorování zranění nebo úmyslné vyprovokování smrtelné situace, která by v reálném světě měla fatální následky, se také považuje za NVL."
                },
                {
                    subtitle: "Příklady",
                    text: "Být obklíčen ozbrojenými postavami a přesto jednat, jako by hrozba neexistovala (např. vytáhnout telefon a zavolat policii bez obav o svůj život).<br/>Úmyslně skočit z vysoké budovy nebo ignorovat vážná zranění.<br/>Vzdorovat loupeži nebo přestřelce, kde je jasné, že vaše postava nemá šanci na přežití."
                }
            ]
        },
        {
            title: "FEAR",
            content: [
                {
                    subtitle: "Popis",
                    text: "Hráči musí mít na paměti, že jejich postava se vždy obává o svůj život. Toto pravidlo platí nejen pro situace, kdy je ohrožen život samotné postavy, ale také pro případy, kdy jiná osoba v blízkosti čelí nebezpečí, které může ohrozit její život."
                },
                {
                    subtitle: "Typy FearRP",
                    text: "GunFear: Strach z hrozby střelnou zbraní.<br/>DogFear: Strach z možného pokousání psem.<br/>JailFear: Strach z možností vězení.<br/>JobFear: Strach z možného ztracení zaměstnání.<br/>CopFear: Hráči by měli projevovat úctu a respekt vůči státním složkám, jako jsou LSPD a další."
                }
            ]
        },
        {
            title: "Combat Comeback",
            content: [
                {
                    subtitle: "Popis",
                    text: "Je zakázáno se vracet zpět do RP akce po deathscreenu s cílem pokračovat v boji nebo agresivním chování. Po smrti nebo útěku z boje je nutné počkat, než se vaše postava realisticky vrátí do situace, pokud to situace vyžaduje."
                }
            ]
        },
        {
            title: "Player Kill",
            content: [
                {
                    subtitle: "Popis",
                    text: "PK je situace, kdy vaše postava ztratí paměť na události, které vedly k její smrti. Po takové události je povinna nechat se ošetřit a následně po dobu 24 hodin RP v roli zraněné osoby."
                },
                {
                    subtitle: "Pravidla",
                    text: "Při deathscreenu jste povinni počkat na příjezd EMS nebo na možný respawn, přičemž se musí vaše postava nacházet v nemocnici, kde se zotavuje z ran."
                },
                {
                    subtitle: "Chování po PK",
                    text: "Po PK máte možnost komunikovat podle charakteru zranění, které vaše postava utrpěla, a řídit se tímto stavem ve hře."
                }
            ]
        },
        {
            title: "Bunnyhop",
            content: [
                {
                    subtitle: "Popis",
                    text: "Je zakázáno spamovat mezerník (skákání) za účelem získání výhody v pohybu, jako je nelegální zrychlení nebo neadekvátní manévrování v rámci roleplay situace."
                }
            ]
        },
        {
            title: "Revenge Kill",
            content: [
                {
                    subtitle: "Popis",
                    text: "Po 24 hodinách od smrti vaší postavy máte možnost vykonat PK, ale musí to být podloženo adekvátním roleplayem. Jakékoliv použití KOS nebo VDM je zakázáno. Při pomstě se musíte řídit realistickým a odpovídajícím chováním v rámci dané situace."
                }
            ]
        },
        {
            title: "Gross RP",
            content: [
                {
                    subtitle: "Popis",
                    text: "Styl nechutného RP do kterého se vztahuje: Znásilnění, Kanibalismus, Sexuální obtěžování (do toho zapadá veškeré SEXRP!) a další surové zacházení."
                },
                {
                    subtitle: "Souhlas",
                    text: "Pro zahájení grossu se musíte před začátkem zeptat všech zúčastněných v L-OOC chatu, zda souhlasí s grossem."
                },
                {
                    subtitle: "Omezení",
                    text: "Tento typ RP nesmí ovlivnit oběť celoživotně. Pokud nebude jeden z účastníků souhlasit, musíte akci ukončit! Když do rozehraného grossu dojde někdo nový, musíte opakovat předešlý krok!"
                },
                {
                    subtitle: "Zákazy",
                    text: "Přísně zakázáno je Gross RP typu rasismus. Mučení je povoleno po domluvě v OOC."
                },
                {
                    subtitle: "Příklad",
                    text: "Useknutí zápěstí, nebo i celé končetiny."
                }
            ]
        },
        {
            title: "Character Kill",
            content: [
                {
                    subtitle: "Popis",
                    text: "Character Kill (CK) je trvalé zabití postavy, po kterém již hráč nemůže pokračovat ve hře s touto postavou."
                },
                {
                    subtitle: "Schválení CK",
                    text: "CK je možné udělit až po schválení žádosti, kterou hráč musí zaslat do ticketu na Discordu."
                },
                {
                    subtitle: "Po CK",
                    text: "Po udělení CK hráč nesmí po dobu 2 týdnů hrát ve stejné frakci nebo nelegální skupině, ve které byl před CK."
                },
                {
                    subtitle: "Ztráta majetku",
                    text: "Po CK hráč ztrácí všechny věci kromě VIP věcí. Přenášení věcí mezi postavami po CK je zakázáno."
                },
                {
                    subtitle: "CK na sídle frakce",
                    text: "Boss frakce může zabít jakéhokoliv člena své frakce, pokud má k tomu pádný důvod a dokáže to obhájit. CK musí být schváleno členy frakce na jejich frakčním Discordu."
                },
                {
                    subtitle: "Zakázané chování",
                    text: "Před plánovaným CK je zakázáno přepisovat majetek na jiného hráče."
                }
            ]
        },
        {
            title: "Jail CK",
            content: [
                {
                    subtitle: "Popis",
                    text: "Tento typ CK může být udělen pouze v případě, že existuje pádný IC důvod a vše je v souladu se zákony. Dále platí všechny body uvedené v pravidlech pro CK."
                }
            ]
        },
        {
            title: "Self CK",
            content: [
                {
                    subtitle: "Popis",
                    text: "Self CK je proces, kdy si hráč sám udělí CK své postavě. Podmínky pro Self CK jsou stejné jako pro běžné CK."
                },
                {
                    subtitle: "Podmínky",
                    text: "Je nutné mít pádný důvod pro tuto akci. Důvod typu 'mám hodně faktur a nemám je jak zaplatit' není platný."
                },
                {
                    subtitle: "Ověření",
                    text: "Pro provedení Self CK je třeba mít videozáznam, nebo požádat admina o spectate v případech, jako jsou vykrádačky nebo podobné situace."
                },
                {
                    subtitle: "Princip",
                    text: "Self CK je obdobné normálnímu CK, ale v tomto případě si hráč uděluje CK sám. Tento typ CK musí mít velmi pádný a realistický důvod."
                }
            ]
        },
        {
            title: "Interní CK",
            content: [
                {
                    subtitle: "Popis",
                    text: "Tento typ CK je udělován pouze bossem a vybranými členy nelegální frakce."
                },
                {
                    subtitle: "Podmínky",
                    text: "Platí pouze pro členy dané nelegální frakce. Boss frakce je povinen do ticketu zaslat screen s důvodem CK."
                }
            ]
        },
        {
            title: "Situační CK",
            content: [
                {
                    subtitle: "Popis",
                    text: "Situační CK je uděleno na základě specifické situace, která nastala."
                },
                {
                    subtitle: "Příklad",
                    text: "Bouračka, pád letadla, těžké zranění apod. Tento typ CK je udělen v souladu s danou situací, která musí být IC důvodem k smrti postavy."
                }
            ]
        }

    ],
    "Pravidla vykrádání/nelegální": [
        {
            title: "Vykrádání banky",
            content: [
                {
                    subtitle: "Rukojmí",
                    text: "Rukojmí nesmí být RPeno passivně. Rukojmí musí aktivně reagovat na situaci a být součástí roleplay akce."
                },
                {
                    subtitle: "Příjezd policie",
                    text: "Po zahájení vykrádání banky je povinné čekat na příjezd policie po dobu minimálně 15 minut. Pokud během této doby policie nedorazí, můžete místo opustit."
                }
            ]
        },
        {
            title: "Vykrádání obchodu",
            content: [
                {
                    subtitle: "Rukojmí",
                    text: "Stejně jako u banky, rukojmí nesmí být RPováno passivně. Musí aktivně reagovat na situaci."
                },
                {
                    subtitle: "Příjezd policie",
                    text: "Při vykrádání obchodu jste povinni čekat na příjezd policie maximálně 10 minut. Pokud do této doby policie nedorazí, můžete místo opustit."
                }
            ]
        },

        {
            title: "Okrádání osob",
            content: [
                {
                    subtitle: "IC důvod",
                    text: "Před zahájením okradení je nutné mít reálný IC důvod. Okrádání by nemělo být bezdůvodné (například \"jen tak\" bez kontextu)."
                },
                {
                    subtitle: "PCo můžete ukrást",
                    text: "Můžete okrást osobu o vše, co má u sebe (peníze, cennosti apod.), ale nesmíte nutit osobu, aby vybrala peníze z banky nebo přepsala majetek."
                },
                {
                    subtitle: "Zákazy",
                    text: "Okrádání nesmí zahrnovat nutnost změny vlastnictví majetku nebo jiné neadekvátní požadavky na oběť."

                }
            ]
        },
        {
            title: "Okrádání státních složek",
            content: [
                {
                    subtitle: "EMS",
                    text: "Okrádání EMS je přísně zakázáno! Tento typ okrádání je proti pravidlům serveru."
                },
                {
                    subtitle: "LSPD/LSSD",
                    text: "Okrádání státních složek, jako je LSPD nebo LSSD, je povoleno pouze pro základní vybavení (např. peníze, rádio, zbraně základní úrovně). Okrádání o dlouhé zbraně nebo speciální vybavení k vykonání činností (např. odznaky, policejní výbava apod.) "
                }
            ]
        },
        {
            title: "Nelegální pravidla",
            content: [
                {
                    subtitle: "",
                    text: "Nelegální frakce může udělit frakční CK bez schválení, ale musí mít pádný důvod pro udělení CK!"
                },
                {
                    subtitle: "",
                    text: "Nelegální frakce není win frakce, proto prosím dbejte na to že s PD se vyjednává, nikoli kropí!\n" +
                        "Nelegálka jako taková má své frakční sídlo + některé i podniky, vázejte se prosím na vaše sídla a podniky, neobsazujte prosím podniky jiné!"
                },
                {
                    subtitle: "",
                    text: "Člen nelegální frakce nemůže být ve 2 zároveň, tím pádem můžete být maximálně v jedné!"
                }
            ]
        },
    ],
    "Gang Pravidla": [
        {
            title: "VL – Vážit si života",
            content: [
                {
                    subtitle: "Popis",
                    text: "Každý gangster by si měl vážit svého života. Jen proto, že jste gangster, neznamená, že se ničeho nebojíte. Jednejte tak, abyste si zbytečně nedělali problémy."
                }
            ]
        },
        {
            title: "CK",
            content: [
                {
                    subtitle: "Popis",
                    text: "Pokud vaše postava dostane CK, je zakázáno se vrátit do stejného gangu po dobu 3 dnů (bude se sledovat!)."
                },
                {
                    subtitle: "Riziko CK",
                    text: "Při přepadu, drive-by apod. musíte počítat s vysokým rizikem CK, pokud dostanete death screen (není to však podmínka)."
                }
            ]
        },
        {
            title: "GrindRP",
            content: [
                {
                    subtitle: "Popis",
                    text: "Není zakázáno vydělávat peníze, ale snažte se to omezit. Gang by měl držet při sobě a ne si jen vydělávat na luxusní auta."
                },
                {
                    subtitle: "Doporučení",
                    text: "Raději se zaměřte na RP mezi gangy, například obchod s drogami, zbraněmi, a pohybujte se převážně v hoodu nebo Down Townu."
                }
            ]
        },
        {
            title: "Backfire",
            content: [
                {
                    subtitle: "Popis",
                    text: "Pokud jste napadeni, nesmíte opětovat palbu, pokud nemáte dostatečné krytí."
                }
            ]
        },
        {
            title: "Kill Ratio",
            content: [
                {
                    subtitle: "Popis",
                    text: "Toto pravidlo souvisí s VL – vážíte si života a bojíte se o něj."
                },
                {
                    subtitle: "Doporučení",
                    text: "Při přepadu, drive-by apod. zabijete maximálně 1–3 lidi a ihned utíkáte, protože se v tu chvíli může nahrnout mnoho dalších, kteří vám mohou způsobit smrtelné zranění."
                }
            ]
        },
        {
            title: "GroupRP",
            content: [
                {
                    subtitle: "Popis",
                    text: "Je skvělé, že se všichni držíte v hoodu nebo Down Townu, ale neměli byste být namačkaní na jednom místě."
                },
                {
                    subtitle: "Doporučení",
                    text: "Rozdělte se do skupin a využívejte celé území."
                }
            ]
        },
        {
            title: "Strach z PD",
            content: [
                {
                    subtitle: "Popis",
                    text: "Nejste terminátoři – PD jsou ti, kteří se s vámi nebudou mazat. Klidně vám dají kulku mezi oči. Je třeba hrát RP s respektem a strachem z nich."
                }
            ]
        },
        {
            title: "Během volného času",
            content: [
                {
                    subtitle: "Doporučené aktivity",
                    text: "Jděte na procházku<br/>Navštivte skatepark nebo jezděte na BMX<br/>Zahrajte si sporty nebo hry (basketbal, kulečník)<br/>Tagujte, ale vyhněte se enemy hoodům a neporušujte passiveRP"
                }
            ]
        },
        {
            title: "Beef mezi gangy",
            content: [
                {
                    subtitle: "Pravidla",
                    text: "Nejčastěji používejte slovní napadání<br/>Střelnou zbraň použijte pouze v krajních situacích, pokud není jiná možnost<br/>Časté používání střelných zbraní bude trestáno"
                }
            ]
        },
        {
            title: "Oblečení a vozidla",
            content: [
                {
                    subtitle: "Oblečení",
                    text: "Nenoste oblečení celé ve vaší gang barvě – poznávacím znakem gangu je pouze šátek/bandana<br/>Bandanu nenoste přes obličej, pokud to není nutné. Pokud nechcete ukázat svou identitu, použijte roušku nebo kuklu<br/>Doporučuje se nosit něco na podporu týmu (např. Ballas – Lakers), ale není to povinné"
                },
                {
                    subtitle: "Vozidla",
                    text: "Jezděte hlavně v levnějších autech<br/>Preferujte BMX, chůzi nebo motorku (např. Sanchez)<br/>BF 400 je pro gangy zakázaná (je příliš silná oproti PD)"
                }
            ]
        },
        {
            title: "PullUp a DriveBy",
            content: [
                {
                    subtitle: "DriveBy",
                    text: "Maximálně 4 lidé<br/>Najedete do hoodu, sejmete cíl a rychle zmizíte<br/>Ideální jsou NPC gang vozidla"
                },
                {
                    subtitle: "PullUp",
                    text: "Přepadnete zezadu, pobodáte nebo postřelíte cíl a utečete<br/>Message musí být rychlá a stručná!"
                }
            ]
        },
        {
            title: "Revenge",
            content: [
                {
                    subtitle: "Pravidla",
                    text: "Nejlépe ho provést až po několika dnech v nečekaný moment<br/>Zaměřte se pouze na osobu, která vám ublížila<br/>Nemůžete někoho jen tak zabít bez předchozí interakce a říct mu náhodnou zprávu"
                },
                {
                    subtitle: "Příklad správné message",
                    text: "Někdo vám včera shodil motorku → pobodáte ho a řeknete: „To máš za tu motorku!“"
                },
                {
                    subtitle: "Příklad nesmyslné message",
                    text: "Přepadnete někoho a řeknete „To máš za GSWC“ – to je nesmysl"
                }
            ]
        },
        {
            title: "PassiveRP",
            content: [
                {
                    subtitle: "Pravidla",
                    text: "V Down Townu passive není (pohybují se tam NPC gangy)<br/>V hoodu byste se měli chovat podle situace (mít respekt a strach)"
                }
            ]
        },
        {
            title: "Tagování",
            content: [
                {
                    subtitle: "Pravidla",
                    text: "Každý gang si označuje území tagováním<br/>Je zakázáno tagovat v enemy hoodu, například „$.S.M on Top“ – porušení se trestá<br/>Používejte reálné fonty, ne Arial apod."
                }
            ]
        },
        {
            title: "Trash RP",
            content: [
                {
                    subtitle: "Zakázáno",
                    text: "Spamování levého tlačítka nebo „R“ při boji<br/>Držení „infinity space“ (neustálé vyhýbání se útokům)<br/>Lezení na střechu pro získání výhody při střelbě<br/>Křičení při pullupu „Ruce nahoru!“, „Ke zdi!“<br/>Pouštění CZ/SK písniček<br/>Okrádání hráče v dead screenu (okrádání se zbraní v ruce je povolené)"
                }
            ]
        },
        {
            title: "Originální postavy",
            content: [
                {
                    subtitle: "Pravidla",
                    text: "Každá postava musí mít v gangu svou roli (např. pěstitel weed, zkušený řidič, ostrostřelec).<br/>Každý gang bude mít místnost nebo sekci, kde se budou uchovávat lore postav."
                }
            ]
        },
        {
            title: "Obecná pravidla",
            content: [
                {
                    subtitle: "Pravidla",
                    text: "Každý člen gangu musí respektovat lore gangu<br/>Toxicita v OOC bude trestána banem<br/>Na gangovém Discordu budou minimálně dva gang admini<br/>Používání Discordu jako vysílačky nebo jiného komunikátoru je zakázáno!"
                }
            ]
        }

    ],
    "Pravidla Nelegální scény": [
        {
            title: "Únos",
            content: [
                {
                    subtitle: "Délka únosu",
                    text: "Maximální doba: Hráče můžete držet maximálně 90 minut reálného času. Během této doby je nutné vést s ním RP interakci, aby byl únos považován za validní.<br/><br/>Prodloužení únosu: Pokud chcete prodloužit dobu únosu, musíte požádat o schválení prostřednictvím /report ve hře nebo Admin-Ticketu na Discordu."
                },
                {
                    subtitle: "Důvod únosu",
                    text: "Adekvátní důvod: Únos musí mít vždy logický a adekvátní RP důvod. Bez pádného důvodu není únos povolen."
                },
                {
                    subtitle: "Únos v městské oblasti",
                    text: "Povinnost informovat: Pokud unášíte hráče v městské oblasti (v Passivu), musíte použít příkaz /911 a poskytnout informace o vozidle, barvě a směru jeho pohybu, aby byla situace zaregistrována."
                },
                {
                    subtitle: "Únos na venkově",
                    text: "Pozor na NPC: Pokud unášíte hráče na venkově, dbejte na to, aby kolem vás nebyly žádné NPC postavy. Pokud ano, musíte okamžitě použít příkaz /911."
                }
            ]
        },
        {
            title: "Střelba a přestřelky",
            content: [
                {
                    subtitle: "Střelba při únosu",
                    text: "Zahájení střelby bez předchozího RP a validního důvodu je zakázáno. Střelba musí být logická a v souladu s RP situací."
                },
                {
                    subtitle: "Vrácení se do oblasti střelby",
                    text: "Je zakázáno se vracet do oblasti střelby s cílem pokračovat v boji. Vaší hlavní prioritou je přežít a dostat se z oblasti střelby, nikoliv pokračovat v akci."
                },
                {
                    subtitle: "Přestřelky s PD a nelegálními frakcemi",
                    text: "Pokud se účastníte přestřelky mezi státními složkami (PD) a nelegálními frakcemi, můžete se do akce vrátit pouze pokud máte za cíl osvobodit svého vůdce nebo člena frakce."
                }
            ]
        },
        {
            title: "Další pravidla pro nelegální RP",
            content: [
                {
                    subtitle: "Zákaz lovení PD pro zbraně",
                    text: "Je zakázáno lovit PD (policii) za účelem obírání je o jejich zbraně. Krádeže policejních zbraní jsou považovány za nezákonné."
                },
                {
                    subtitle: "Důkazy pro krádeže",
                    text: "Pro usvědčení jednotlivce nebo skupiny z krádeže vozidla nebo držení pěstírny/laboratoře musíte mít konkrétní a dostatečné důkazy. Není dovoleno jednat pouze na základě domněnek."
                },
                {
                    subtitle: "Rozpoznávání osob",
                    text: "Není dovoleno rozpoznávat osoby pouze na základě jejich vzhledu. Identifikace musí probíhat na základě RP informací."
                },
                {
                    subtitle: "Spojování s nelegálními skupinami",
                    text: "Spojování s jinými nelegálními skupinami za účelem zničení jiné frakce je zakázáno, pokud to není povoleno prostřednictvím Ticketu pro vedení serveru. Povolené je pouze předávání informací mezi nelegálními skupinami."
                }
            ]
        },
        {
            title: "Raid",
            content: [
                {
                    subtitle: "Schválený raid",
                    text: "Raid na cizí vilu nebo pozemek je povolen pouze v případě, že máte validní důvod a schválený ticket."
                },
                {
                    subtitle: "Informace pro raid",
                    text: "Musíte mít dostatečné informace pro provedení raidu, aby byl RP akce považována za validní a logickou."
                }
            ]
        }

    ],
    "Pravidla Cayo Perico": [
        {
            title: "Legální část",
            content: [
                {
                    subtitle: "Passive RP",
                    text: "Na legální části Cayo Perica je povinný Passive RP, což znamená, že zde platí pravidla týkající se roleplay interakcí, jako jsou například letištní kontroly a interakce s policií (PD)."
                }
            ]
        },
        {
            title: "Nelegální část",
            content: [
                {
                    subtitle: "Passive RP",
                    text: "Na nelegální části Cayo Perica neplatí Passive RP. To znamená, že zde není nutné dodržovat pasivní roleplay chování, například u letištních kontrol a státních složek."
                },
                {
                    subtitle: "KOS",
                    text: "Na nelegální části Cayo Perica neplatí pravidlo KOS (Kill on Sight). To znamená, že hráči nemohou bezdůvodně zabíjet ostatní hráče pouze na základě jejich přítomnosti v této oblasti, pokud k tomu nemají platný důvod a kontext v rámci RP."
                }
            ]
        },
        {
            title: "",
            content: [
                {
                    subtitle: "",
                    text: "<img src='https://i.imgur.com/GVaSpyE.png' alt='Cayo Perico mapa'/>"
                }
            ]
        }
    ]

};


export default function Rules() {
    const [activeCategory, setActiveCategory] = useState("Základní Pravidla");

    return (
        <section className="min-h-screen bg-[#171717] text-white px-6 py-24">
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-10">
                {/* Sidebar */}
                <aside id="rules-categories-list" className="md:w-1/4">
                    <ul className="space-y-3 border-l border-white/20 pl-4">
                        {categories.map((cat) => (
                            <li
                                key={cat}
                                onClick={() => setActiveCategory(cat)}
                                className={`cursor-pointer flex items-center gap-2 px-2 py-1 rounded transition hover:bg-white/10 ${
                                    activeCategory === cat ? "text-orange-500 font-semibold border-l-4 border-orange-500 pl-2" : "text-white"
                                }`}
                            >
                                <FaFileAlt className="text-sm" />
                                {cat}
                            </li>
                        ))}
                    </ul>
                </aside>

                <div className="md:w-3/4 space-y-6">
                    <h2 className="text-3xl font-bold text-orange-500 mb-6 border-b border-white/10 pb-2">
                        {activeCategory}
                    </h2>

                    {rulesData[activeCategory] ? (
                        <>
                            {rulesData[activeCategory].map((block, index) => (
                                <div key={index} data-aos="fade-up" className="bg-white/5 p-6 rounded-lg border border-orange-500 shadow-md">
                                    <h3 className="text-2xl font-bold text-orange-400 mb-4">{block.title}</h3>

                                    {block.content.map((item, subIndex) => (
                                        <div key={subIndex} className="mb-4">
                                            {item.subtitle && (
                                                <h4 className="text-lg font-semibold text-white mb-1">{item.subtitle}</h4>
                                            )}
                                            <p
                                                className="text-gray-300"
                                                dangerouslySetInnerHTML={{ __html: item.text }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            ))}

                            {/* Link zpět na výběr kategorií */}
                            <div className="text-right mt-8">
                                <a href="#rules-categories-list" className="text-orange-400 hover:underline">
                                    ← Zpět na seznam kategorií
                                </a>
                            </div>
                        </>
                    ) : (
                        <p className="text-gray-400 italic">Pravidla pro tuto sekci zatím nejsou dostupná.</p>
                    )}
                </div>
            </div>
        </section>
    );
}
